import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ButtonComponent } from './button.component';
import { Owner } from '../../../models/entities/owner';

@Component({
    selector: 'app-owner-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class OwnerButtonComponent extends ButtonComponent implements OnChanges
{
    @Input() owner: Owner;

    constructor() {
        super();
        this.type = 'link';
        this.svg = 'user';
        this.hostClass += ' owner-button';
        this.iconClassesCallback = () => this.iconClassSet.add('align-items-start');
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);

        if ('owner' in changes) {
            this.label = this.getLabel();
        }
    }

    getLabel() {
        return this.owner?.name || 'No Name';
    }
}
